export class Search {
  constructor(
    public query: string,
    public location: string,
    public language: string,
    public insurance: string,
    public latitude: number,
    public longitude: number
  ) { }
}
